import React from 'react';
import {ButtonV2} from '../../../../system/ButtonV2/ButtonV2';
import {faTwitch} from '@fortawesome/free-brands-svg-icons';
import classNames from 'classnames';

import {Report} from '../../../../types/Api/Reports';
import {UserInfo} from '../../../../PulsoidClient';

import css from './ReportsV2ViewEmptyState.module.scss';

export type ReportsV2ViewEmptyStateProps = {
  twitchUrl: string;
  profile?: UserInfo;
  report?: Report;
  clipsSettings: any;
};

export const ReportsV2ViewEmptyState = ({
  twitchUrl,
  profile,
  report,
  clipsSettings,
}: ReportsV2ViewEmptyStateProps) => {
  return (
    <div
      className={classNames(css.clipsEmptyState, {
        [css.noClips]: !report?.clips?.length,
      })}
    >
      {!report?.clips?.length ? (
        <div className={css.clipsEmptyStateBackground}>
          <div className={css.clipsEmptyStateBackgroundBlock} />
          <div className={css.clipsEmptyStateBackgroundBlock} />
          <div className={css.clipsEmptyStateBackgroundBlock} />
          <div className={css.clipsEmptyStateBackgroundBlock} />
          <div className={css.clipsEmptyStateBackgroundBlock} />
          <div className={css.clipsEmptyStateBackgroundBlock} />

          <div className={css.clipsEmptyStateBackgroundOverlay} />
        </div>
      ) : null}

      {!profile?.isTwitchConnected ? (
        <>
          <h5 className={css.clipsEmptyStateTitle}>
            Connect your Twitch account to start
            <br /> automating clips for your future streams
          </h5>

          <ButtonV2
            className={css.emptyStateCta}
            type="twitch"
            href={twitchUrl}
            prefixIcon={faTwitch}
          >
            Connect Twitch Account
          </ButtonV2>
        </>
      ) : null}

      {clipsSettings?.status?.toLowerCase() === 'off' &&
      profile?.isTwitchConnected ? (
        <>
          <h5 className={css.clipsEmptyStateTitle}>
            Enable automated clips for your future streams
          </h5>

          <ButtonV2
            href="/ui/profile/settings"
            type="primary-outline"
            className={css.emptyStateCta}
          >
            Go to Settings
          </ButtonV2>
        </>
      ) : null}

      {!report?.clips?.length &&
      clipsSettings?.status?.toLowerCase() !== 'off' &&
      profile?.isTwitchConnected ? (
        <>
          <h5 className={css.clipsEmptyStateTitle}>
            No clips generated for this stream
          </h5>
          <div className={css.clipsEmptyStateText}>
            To get more automated clips for your future streams, adjust clip
            triggers
          </div>

          <ButtonV2
            href="/ui/profile/settings"
            type="primary-outline"
            className={css.emptyStateCta}
          >
            Go to Settings
          </ButtonV2>
        </>
      ) : null}
    </div>
  );
};
